import { useQuery } from "react-query";
import { EMPTY_SSR_STATE } from "shared/helpers/ssrCache";






export const ssrStateKey = (machine) => ["ssrState", machine];



export const useSsrState = (machine) => {
  const { data } = useQuery(ssrStateKey(machine), {
    enabled: false,
  });
  return data || EMPTY_SSR_STATE;
};
